import {createSelector} from 'reselect';
import {AppState} from '../..';

export const loginResponseSelector = () =>
  createSelector(
    (state: AppState) => state.login.loginResponse,
    (item) => item,
  );

export const loginSelector = () =>
  createSelector(
    (state: AppState) => state.login.login,
    (item) => item,
  );

export const sendCodeResponseSelector = () =>
  createSelector(
    (state: AppState) => state.login.sendCodeResponse,
    (item) => item,
  );
